import { useState } from 'react';
import { Bot, MessagesSquare } from 'lucide-react';
import WhatsappBot from './WhatsappBot';
import WhatsappGroups from './WhatsappGroups';

type Tab = 'bot' | 'groups';

export default function WhatsappPage() {
  const [tab, setTab] = useState<Tab>('bot');

  return (
    <div className="space-y-5">
      <div>
        <h2 className="text-lg font-semibold text-slate-900">WhatsApp</h2>
        <p className="text-sm text-slate-500 mt-0.5">
          Configura el bot que vive en grupos de WhatsApp y los grupos autorizados a generar tickets.
        </p>
      </div>

      <div className="border-b border-slate-200">
        <nav className="flex gap-1 -mb-px">
          <TabButton active={tab === 'bot'} onClick={() => setTab('bot')} icon={Bot}>
            Bot
          </TabButton>
          <TabButton active={tab === 'groups'} onClick={() => setTab('groups')} icon={MessagesSquare}>
            Grupos
          </TabButton>
        </nav>
      </div>

      {tab === 'bot' ? <WhatsappBot /> : <WhatsappGroups />}
    </div>
  );
}

function TabButton({
  active,
  onClick,
  icon: Icon,
  children,
}: {
  active: boolean;
  onClick: () => void;
  icon: typeof Bot;
  children: React.ReactNode;
}) {
  return (
    <button
      onClick={onClick}
      className={`inline-flex items-center gap-1.5 px-3 py-2 text-sm border-b-2 transition ${
        active
          ? 'border-slate-900 text-slate-900 font-medium'
          : 'border-transparent text-slate-500 hover:text-slate-900'
      }`}
    >
      <Icon size={14} />
      {children}
    </button>
  );
}
